module.exports = __webpack_public_path__ + "img/testpaper_next_left.2ee4299e.svg";